import React from "react";
import autosureLogo from '../images/Autosure/autosure-footer.png';
import {useLocation} from "react-use";
import {detectSource} from "../utils/sourceDetection";

const Footer = props => {

    const openInNewTab = (url) => {
        const newWindow = window.open(url, "_blank");
        newWindow.focus();
    };
    const location = useLocation();
    const source = detectSource();
  const isCustomer = source === 'AA' || source === 'AA_MEMBER' || source === 'VTNZ' || source === 'GASPY';

    return (<>
      <div style={{display: "flex", alignItems: "flex-start"}}>
            <div className="footerMobile footerPadding footerFixed placeholderRegularTextStyles">
              <div className="column-on-mobile" style={{
                    display: "flex",
                    justifyContent: 'center',
                    paddingTop: '16px',
                    alignItems: "center",
                paddingBottom: '15px'
                }}>
                    <div style={{paddingRight: '30px', margin: 0}}>
                      This insurance is underwritten by {" "}
                      <span
                        className="spanLink"
                        onClick={() => openInNewTab("https://autosure.co.nz/")}
                      > Autosure Insurance Limited </span>
                      <br/>
                      <span className='spanLink' onClick={() => {
                        isCustomer ? window.location = "tel:0800262411" : window.location = "tel:0800267873"
                      }}>{isCustomer ? "0800 262 411" : "0800 267 873"}</span> | <span className='spanLink'
                                                                                       onClick={() => {
                      window.location = "mailto:support@autosure.co.nz"
                    }}>support@autosure.co.nz </span>| <span style={{whiteSpace: 'nowrap'}}> © Autosure Insurance Limited</span>{" "}
                        | <span className='spanLink'
                                onClick={() => openInNewTab("https://autosure.co.nz/privacy-policy/")}>Privacy</span> |{' '}
                      <span className="spanLink" onClick={() => openInNewTab("https://autosure.co.nz/terms-of-use/")}>
            Terms of Use
        </span>
                    </div>
                <div style={{paddingTop: '10px'}}>
                  <a href="https://autosure.co.nz/" target="_blank" rel="noopener noreferrer">
                    <img src={autosureLogo} style={{height: "inherit", cursor: "pointer"}} alt="Autosure Logo"/>
                  </a>
                </div>
                </div>
            </div>
        </div>
    </>);
}

export default Footer;
